import Name from "./components/Name.vue"
import AddressCityStateZipCode from "./components/AddressCityStateZipCode.vue"
import DateOfBirth from "./components/DateOfBirth.vue"
import Email from "./components/Email.vue"

import VehicleConfirmation from "./components/VehicleConfirmation.vue"
import VehicleYear from "./components/VehicleYear.vue"
import VehicleMake from "./components/VehicleMake.vue"
import VehicleModel from "./components/VehicleModel.vue"
import VehicleTrim from "./components/VehicleTrim.vue"
import VehicleVin from "./components/VehicleVin.vue"
import VehiclePrimaryUseType from "./components/VehiclePrimaryUseType.vue"
import VehicleOwnershipType from "./components/VehicleOwnershipType.vue"
import VehicleAnnualMileage from "./components/VehicleAnnualMileage.vue"
import VehicleDaysDrivenPerWeek from "./components/VehicleDaysDrivenPerWeek.vue"
import AddAnotherVehicle from "./components/AddAnotherVehicle.vue"

import IsInsured from "./components/IsInsured.vue"
import CurrentInsurer from "./components/CurrentInsurer.vue"
import InsuranceLength from "./components/InsuranceLength.vue"
import RequestedCoverageType from "./components/RequestedCoverageType.vue"
import NumberOfDrivers from "./components/NumberOfDrivers.vue"
import LicenseStatus from "./components/LicenseStatus.vue"
import AccidentsOrTicketsInPast3Years from "./components/AccidentsOrTicketsInPast3Years.vue"
import Dui from "./components/Dui.vue"
import NeedsSr22 from "./components/NeedsSr22.vue"
import CreditRating from "./components/CreditRating.vue"
import IsMarried from "./components/IsMarried.vue"
import CurrentResidenceType from "./components/CurrentResidenceType.vue"
import IsInterestedInHomeOrRentersInsuranceQuotes from "./components/IsInterestedInHomeOrRentersInsuranceQuotes.vue"
import CurrentResidenceLength from "./components/CurrentResidenceLength.vue"
import Gender from "./components/Gender.vue"
import PhoneNumber from "./components/PhoneNumber.vue"

const steps = {
    Name,
    AddressCityStateZipCode,
    DateOfBirth,
    Email,

    VehicleConfirmation,
    VehicleYear,
    VehicleMake,
    VehicleModel,
    VehicleTrim,
    VehicleVin,
    VehiclePrimaryUseType,
    VehicleOwnershipType,
    VehicleAnnualMileage,
    VehicleDaysDrivenPerWeek,
    AddAnotherVehicle,

    IsInsured,
    CurrentInsurer,
    InsuranceLength,
    RequestedCoverageType,
    NumberOfDrivers,
    LicenseStatus,
    AccidentsOrTicketsInPast3Years,
    Dui,
    NeedsSr22,
    CreditRating,
    IsMarried,
    CurrentResidenceType,
    IsInterestedInHomeOrRentersInsuranceQuotes,
    CurrentResidenceLength,
    Gender,
    PhoneNumber
};

export default {
    functional: true,
    props: {
        step: String
    },
    render(createElement, context) {
        if (!steps[context.props.step]) {
            return createElement(steps["Name"], context.data, context.childred);
        }
        return createElement(steps[context.props.step], context.data, context.children)
    }
}
